import { Component, OnInit } from '@angular/core';
import { ROUTES } from './side-nav-routes.config';
import { ThemeConstantService } from '../../services/theme-constant.service';
import { HeaderService } from '../header/header.service';
import { HeaderComponent } from '../header/header.component';
import { UtilsService } from 'src/app/utils/services/utils.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { Router } from '@angular/router';
import { FormBuilder } from '@angular/forms';
import { AuthenticationService } from '../../services/authentication.service';
import { RemuneracionesExternalService } from 'src/app/pages/remunerations/remuneraciones-external.service';

@Component({
    selector: 'app-sidenav',
    templateUrl: './side-nav.component.html',
    styleUrls: ['./side-nav.component.scss']
})

export class SideNavComponent implements OnInit {

    public menuItems: any[];
    isFolded: boolean;
    isSideNavDark: boolean;
    admin: boolean;
    avatarUrl = "";
    companyName: "";

    isVisible = false;
    selectedCompany = null;
    companies = [];

    headerComponent;

    constructor(
        private themeService: ThemeConstantService,
        private headerService: HeaderService,
        private utilsService: UtilsService,
        private router: Router,
        private msg: NzMessageService,
        private fb: FormBuilder,
        private authenticationService: AuthenticationService,
        private remuneracionesService: RemuneracionesExternalService,
    ) {
        this.headerComponent = new HeaderComponent(
            themeService, headerService, utilsService, router, msg, fb, authenticationService,
            remuneracionesService,
        );
    }

    ngOnInit(): void {
        this.checkAdmin();
    }

    linkClick(url) {
        this.router.routeReuseStrategy.shouldReuseRoute = () => false;
        this.router.navigate([url]);
    }

    checkAdmin(){
        this.headerService.getProfile()
		.subscribe(data => {
            this.avatarUrl = data['avatar_small'];
            this.admin = data.admin;
            this.companies = data.companies;
            this.companyName = data['pin_current_company']['name'];
            this.menuItems = ROUTES.filter(menuItem => menuItem);
            this.themeService.isMenuFoldedChanges.subscribe(isFolded => this.isFolded = isFolded);
            this.themeService.isSideNavDarkChanges.subscribe(isDark => this.isSideNavDark = isDark);
		},
		err => {
            console.error('Error to get Transactions');
            console.error(err);
		});
    }

    toggleFold(link) {
        if (link !== '') {
            this.router.navigate([link]);
            this.headerComponent.toggleExpand(false);
        } else {
            this.headerComponent.toggleFold();
        }
    }


    onClick(){
        if (this.isFolded === false){
            this.themeService.toggleFold(true);
        }
    }

    showModal(){
        this.isVisible = true;

    }

    hideModal(){
        this.isVisible = false;
    }

    chooseCompany(){
        if (this.selectedCompany !== null){
            this.headerService.setCurrentCompany(this.selectedCompany)
            .subscribe(data => {
                this.router.routeReuseStrategy.shouldReuseRoute = () => false;
                this.router.onSameUrlNavigation = 'reload';
                this.router.navigate(['/indicators']);
                this.isVisible = false;
            },
            err => {
                console.error('Error to set company');
                console.error(err);
            });
        }else {
            this.msg.info('Debe seleccionar una empresa');
        }

    }

    titleCase(str){
        return this.utilsService.titleCase(str);
    }

    isItemActive(item): boolean {
        return item.father === this.router.url.split('/')[1];
    }

    isSubItemActive(subItem): boolean {
        return subItem.path === ('/' + this.router.url.split('/')[1] + '/' + this.router.url.split('/')[2]);
    }

}
